export default __webpack_public_path__ + "static/media/brand4.e02a6208.png";